export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkPlatform: "nav-link-platform",
  linkTechnology: "nav-link-technology",
  linkAI: "nav-link-ai",
  linkApplications: "nav-link-applications",
  linkTeam: "nav-link-team",
  linkResearch: "nav-link-research",
  ctaContact: "nav-cta-contact",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  canvas: "hero-canvas",
  headline: "hero-headline",
  ctaPlatform: "hero-cta-platform",
  ctaScience: "hero-cta-science",
  fallback: "hero-fallback",
};

export const CTA = {
  finalPrimary: "final-cta-primary",
  finalSecondary: "final-cta-secondary",
  openContact: "open-contact-dialog",
};

export const CONTACT = {
  dialog: "contact-dialog",
  name: "contact-name",
  email: "contact-email",
  org: "contact-org",
  interest: "contact-interest",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
  mailto: "contact-mailto-link",
};
